<script>
    import moment from 'moment-jalaali'
    const minimumTwelve = moment('12:00:00', 'HH:mm:ss')
    let requestMinimumMinute = 4
    if(localStorage.getItem('wacc') !== null){
        let wacc = JSON.parse(localStorage.getItem('wacc'))
        requestMinimumMinute = +wacc.v.requestMinimumMinute / 60
    }
    else{
        requestMinimumMinute = 4
    }
    const fourHoursLater = moment(moment(Date.now()).format('jYYYY/jM/jD HH:mm:00')).add(requestMinimumMinute, 'hours').format('HH:mm:ss')
    export default {
        mounted () {
            this.customValidations()
        },
        methods: {
            customValidations () {

                this.$validator.extend('mobile', {
                    getMessage: (name) => name + ' ' + ' is not valid ',
                    validate: (value) => {
                        return value.match(/^09\d{9}$/g) !== null
                    }
                })


                this.$validator.extend('english', {
                    getMessage: (name) => name + ' ' + this.$t('validation.english'),
                    validate: value => {return value.match(/[a-z A-Z]/g) !== null}
                })

                this.$validator.extend('persian', {
                    getMessage: (name) => name + '' + this.$t('validation.persian'),
                    validate: value => {return value.match(/[آ-ی]/g) !== null}
                })

                this.$validator.extend('IpAddress', {
                    getMessage: (name) => 'Please enter a valid ' + name,
                    validate: value => {return value.match(/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/g) !== null}
                })

                this.$validator.extend('digit', {
                    getMessage: (name) => name + ' ' + this.$t('validation.digit'),
                    validate: value => {return value.match(/[0-9]/g) !== null}
                })

                this.$validator.extend('nonAlphaNumeric', {
                    getMessage: () => this.$t('validation.nonAlphaNumeric'),
                    validate: value => {return value.match(/[^a-zA-Z\d\s:]/g) !== null}
                })
                this.$validator.extend('lessThan', {
                    getMessage: (name, num) => name + ' ' + ' must be less than ' + num,
                    validate: (num, value) => {
                        return +value > +num
                    }
                })

                this.$validator.extend('lessOrEqualThan', {
                    getMessage: (name, num) => name + ' ' + ' must be equal or less than ' + num,
                    validate: (num, value) => {
                        return +value >= +num
                    }
                })

                this.$validator.extend('tableIdO', {
                    getMessage: (name) => name + ' must not be include O, 0 characters',
                    validate: value => {return value.match('O') === null}
                })

                this.$validator.extend('tableIdZiro', {
                    getMessage: (name) => name + ' must not be include O, 0 characters',
                    validate: value => {return value.match('0') === null}
                })
            }
        }

    }
</script>
